export default {
  name: 'Auto Push Notifications',
  htmlId: 'autoPushNotifications',
};
